import request from '../../utils/request'
import { judgePermissions } from '@/utils/common.js'

const state = {}

const actions = {
    // 获取实训环境管理列表
    getTrainingList({ dispatch }, data) {
        return new Promise((resolve)=>{
            judgePermissions(['training:instance:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/training/instance`,
                        method: 'get',
                        params: data
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve({data:null})
                }
            })
        })
    },

    // 获取实训镜像列表
    getTrainingMirrorList({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/training/mirror`
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 启动实训环境
    postTrainingInstances({dispatch},id){
        return new Promise((resolve)=>{
            request({
                url: `/api/training/instances`,
                method: "post",
                data: {id}
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 停止实训环境
    putTrainingInstances({dispatch},id){
        return new Promise((resolve)=>{
            request({
                url: `/api/training/instances`,
                method: "put",
                data: {id}
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 删除实训环境
    deleteTrainingInstances({dispatch},id){
        return new Promise((resolve)=>{
            request({
                url: `/api/training/instances`,
                method: "delete",
                data: {id}
            }).then((data)=>{
                resolve(data);
            })
        })
    },
}

export default {
    state,
    actions
}